import React, { useState, useEffect } from "react";
import { StyledEngineProvider } from "@mui/material/styles";
import {
  Box,
} from "@material-ui/core";
import RequirementsForGenAI from "./RequirementsForGenAI";
// import { ReactAuthWrapper } from "@carrier/reactauthwrapper";

import { ReactAuthWrapper } from "@carrier-sce-sharedpackages/reactauthwrapper";
import appConfig from "./config";
import { Container } from "@material-ui/core";


function App({ fetchAPI }) {
  const [appAccess, setAppAccess] = useState(false);
  const callback = (permissions) => {
    console.log("permissions->", permissions);
    if (permissions.appAccess) {
      console.log("permissions->", permissions.appAccess);
      setAppAccess(true);
    }
  };
  // For Client Side protection from clickjacking -- Implemented frame busting
  useEffect(() => {
    if (window.self !== window.top) {
      window.top.location = window.self.location;
    }
  }, []);

  return (
    <ReactAuthWrapper appConfig={appConfig.api} getPermissions={callback} >
      {appAccess ? (<div className="App">
        <StyledEngineProvider injectFirst>
          <Box>
            <RequirementsForGenAI fetchAPI={fetchAPI} />
          </Box>
        </StyledEngineProvider>
      </div>) : (
        <Container>
          <div></div>
        </Container>
      )}

    </ReactAuthWrapper>
  );
}

export default App;
